"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialIcons = exports.FooterBottom = exports.StyledCol = exports.StyledLink = exports.StyledFooter = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  background: ", ";\n  line-height: 1.5;\n  padding: 70px 0px 35px;\n  color: ", ";\n"], ["\n  background: ", ";\n  line-height: 1.5;\n  padding: 70px 0px 35px;\n  color: ", ";\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  a,\n  span {\n    color: ", ";\n    font-size: ", ";\n    text-transform: ", ";\n    font-weight: ", ";\n    &:hover {\n      color: ", ";\n    }\n  }\n"], ["\n  a,\n  span {\n    color: ", ";\n    font-size: ", ";\n    text-transform: ", ";\n    font-weight: ", ";\n    &:hover {\n      color: ", ";\n    }\n  }\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  text-align: center;\n  @media ", " {\n    text-align: right;\n    /* text-align: ", "; */\n    \n  }\n"], ["\n  text-align: center;\n  @media ", " {\n    text-align: right;\n    /* text-align: ", "; */\n    \n  }\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  border-top: 1px solid ", ";\n  margin-top: 50px;\n  padding: 50px 0px 20px;\n  text-align: center;\n  .copyright {\n    font-size: 13px;\n  }\n"], ["\n  border-top: 1px solid ", ";\n  margin-top: 50px;\n  padding: 50px 0px 20px;\n  text-align: center;\n  .copyright {\n    font-size: 13px;\n  }\n"]),
    _templateObject5 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  border-radius: ", ";\n  border: 1px solid ", ";\n  display: inline-block;\n  margin: 0 7px;\n  width: 45px;\n  height: 45px;\n  text-align: center;\n  line-height: 45px;\n  &:hover {\n    color: ", ";\n    border-color: ", ";\n  }\n"], ["\n  color: ", ";\n  font-size: ", ";\n  border-radius: ", ";\n  border: 1px solid ", ";\n  display: inline-block;\n  margin: 0 7px;\n  width: 45px;\n  height: 45px;\n  text-align: center;\n  line-height: 45px;\n  &:hover {\n    color: ", ";\n    border-color: ", ";\n  }\n"]);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _globalCss = require("../../../styles/globalCss");

var variable = _interopRequireWildcard(_globalCss);

var _colors = require("../../../styles/colors");

var colors = _interopRequireWildcard(_colors);

var _breakpoints = require("../../../styles/breakpoints");

var _breakpoints2 = _interopRequireDefault(_breakpoints);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledFooter = exports.StyledFooter = _styledComponents2.default.footer(_templateObject, function (props) {
  return props.footerBgColor || colors.darkBg;
}, function (props) {
  return props.textColor || colors.whiteColor;
});

var StyledLink = exports.StyledLink = _styledComponents2.default.div(_templateObject2, function (props) {
  return props.linkColor || colors.whiteColor;
}, function (props) {
  return props.fontSize || variable.baseFont;
}, function (props) {
  return props.textTransform;
}, function (props) {
  return props.fontWeight || variable.fontRegular;
}, function (props) {
  return props.hoverColor || colors.whiteColor;
});

var StyledCol = exports.StyledCol = _styledComponents2.default.div(_templateObject3, _breakpoints2.default.tablet, function (props) {
  return props.textAlign || {};
});

var FooterBottom = exports.FooterBottom = _styledComponents2.default.div(_templateObject4, function (props) {
  return props.borderTop || colors.greyColor2;
});

var SocialIcons = exports.SocialIcons = _styledComponents2.default.a(_templateObject5, function (props) {
  return props.iconColor || {};
}, function (props) {
  return props.fontSize || variable.baseFont;
}, function (props) {
  return props.radius;
}, function (props) {
  return props.borderColor || colors.whiteColor;
}, function (props) {
  return props.iconHoverColor || colors.whiteColor;
}, function (props) {
  return props.hoverBorderColor;
});